(function ($) {
    document.addEventListener('DOMContentLoaded', function () {

        const section = document.querySelector('.report-inside');
        if (!section) return;

        const rows = section.querySelectorAll('.report-inside__row');
        const timeline = section.querySelector('.report-inside__timeline');
        const progressLine = section.querySelector('.report-inside__timeline-progress');

        if (!rows.length) return;

        rows.forEach((row, index) => {

            const dot = document.createElement('div');
            dot.classList.add('report-inside__timeline-dot');

            timeline.appendChild(dot);

            const updateDotPosition = () => {
                const rowTop = row.offsetTop;
                dot.style.top = rowTop + 'px';
            };

            updateDotPosition();
            window.addEventListener('resize', updateDotPosition);
        });

        const dots = section.querySelectorAll('.report-inside__timeline-dot');

        function updateTimeline() {

            let activeIndex = 0;

            rows.forEach((row, index) => {
                const rect = row.getBoundingClientRect();

                if (rect.top <= window.innerHeight * 0.5) {
                    activeIndex = index;
                }
            });

            dots.forEach(dot => dot.classList.remove('is-active'));

            if (dots[activeIndex]) {
                dots[activeIndex].classList.add('is-active');

                const activeDotTop = dots[activeIndex].offsetTop;
                progressLine.style.height = activeDotTop + 'px';
            }
        }

        window.addEventListener('scroll', updateTimeline);
        updateTimeline();
    });




})(jQuery);